import React from 'react';
import { CheckCircle, AlertCircle } from 'lucide-react';
import { Modal } from 'common/components/Modal';
import { Button } from 'common/components/Button';
import { NotificationModalProps } from './NotificationModal.types';
import styles from './NotificationModal.module.scss';

export const NotificationModal: React.FC<NotificationModalProps> = ({ isOpen, type, title, message, onClose }) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose} title={title} size='sm' showDefaultFooter={false}>
            <div className={styles.notificationContent}>
                <div className={`${styles.notificationMessage} ${styles[type]}`}>
                    {type === 'success' && <CheckCircle className={styles.icon} size={24} />}
                    {type === 'error' && <AlertCircle className={styles.icon} size={24} />}
                    <p>{message}</p>
                </div>
            </div>
            <div className={styles.actions}>
                <Button variant='primary' size='md' onClick={onClose}>
                    OK
                </Button>
            </div>
        </Modal>
    );
};
